import Api from './baseApi';

export default {
  getActivityLogs: ({ type, subType, date }) =>
    Api.get('/api/activity-logs/get-logs', {
      params: {
        type,
        subType,
        date,
      },
    }),
};

